<template>
    <div v-if="videos && videos.length">
        <div class="flex items-center gap-4 mb-4 items-center">
            <h3 class="text-2xl text-dark font-bold">
                Latest {{ usePage().props.value.config.name }} videos
            </h3>

            <AppButton v-if="route().has('videos.index')" size="small" :href="route('videos.index')">
                View All
            </AppButton>

            <SubscribeButton class="ml-auto"></SubscribeButton>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div v-for="video of videos" class="group">
                <AppVideo :type="video.type" :clip="video.video_id" class="mb-4"></AppVideo>

                <a :href="getLinkForVideo(video)"
                   target="_blank"
                   class="underline text-lg text-black group-hover:text-primary">{{
                        video.title
                    }}</a>
            </div>
        </div>
    </div>
</template>

<script setup>
import AppButton from "@/Components/AppButton";
import AppVideo from "@/Components/AppVideo";
import SubscribeButton from "@/Components/Videos/SubscribeButton";
import {usePage} from "@inertiajs/inertia-vue3";
import {ref, computed} from "vue";

const props = defineProps({
    videos: Array
});

const getLinkForVideo = video => {
    if (video.type === "youtube") {
        return `https://www.youtube.com/watch?v=${video.video_id}`;
    } else if (video.type === "vimeo") {
        return `https://vimeo.com/${video.video_id}`;
    }
};
</script>

<style scoped>

</style>
